//table columns for evaluation users.

export const showDeliveryManager = [
  { title: 'Evaluation Requests', dataIndex: 'Evaluation Requests', key: 'Evaluation Requests' },
  { title: 'Total Evaluations', dataIndex: 'Total Evaluations', key: 'Total Evaluations' },
  { title: 'Evaluations Open', dataIndex: 'Evaluations Open', key: 'Evaluations Open' },
  { title: 'Evaluations Verified', dataIndex: 'Evaluations Verified', key: 'Evaluations Verified' },
  //   { title: 'Score Upload In Progress', dataIndex: 'Score Upload In Progress', key: 'Score Upload In Progress' },
  //   { title: 'Score Finalised', dataIndex: 'Score Finalised', key: 'Score Finalised' },
]

export const showEvaluationIncharge = [
  { title: 'Evaluation Requests', dataIndex: 'Evaluation Requests', key: 'Evaluation Requests' },
  { title: 'Evaluations Created', dataIndex: 'Evaluations Created', key: 'Evaluations Created' },
  { title: 'Evaluations Open', dataIndex: 'Evaluations Open', key: 'Evaluations Open' },
  { title: 'Evaluations Verified', dataIndex: 'Evaluations Verified', key: 'Evaluations Verified' },
]

export const showEvaluator = [
  { title: 'Evaluation Requests', dataIndex: 'Evaluation Requests', key: 'Evaluation Requests' },
  { title: 'Evaluations Assigned', dataIndex: 'Evaluations Assigned', key: 'Evaluations Assigned' },
  { title: 'Evaluations Open', dataIndex: 'Evaluations Open', key: 'Evaluations Open' },
  { title: 'Evaluations Verified', dataIndex: 'Evaluations Verified', key: 'Evaluations Verified' },
]
